import { EVENTS } from './core/constants';
import { itemsWithPromotion } from './core/promotion';

import { legacyGetters } from './params/legacy';
import { getAuthActionType } from './params/authAction';
import { metaAdapter } from './params/adapters/meta';
import { decoAdapter } from './params/adapters/deco';
import { nvAdapter } from './params/adapters/nv';
import { reservaAdapter } from './params/adapters/reserva';
import { animaleAdapter } from './params/adapters/animale';
import { headlessAdapter } from './params/adapters/headless';
import { pickupAdapter } from './params/adapters/pickup';
import { orderFormAdapter } from './params/adapters/orderForm';

import type { EventName, EventContext, AdapterPayload, InitialConfig } from './types';

type GetterFn = (context: EventContext, config: InitialConfig) => unknown
type EventRequiredParams = { requiredParams: string[] } | undefined;

const adapters = {
  DECO: decoAdapter,
  RESERVA: reservaAdapter,
  HEADLESS: headlessAdapter,
  PICKUP: pickupAdapter,
  ORDERFORM: orderFormAdapter,
  META: metaAdapter,
  ANIMALE: animaleAdapter,
  NV: nvAdapter
} as const;

type AdapterKey = keyof typeof adapters

export async function getParameters(
  context: AdapterPayload,
  eventName: EventName,
  config: InitialConfig
) {
  const eventConfig = EVENTS[eventName] as unknown as EventRequiredParams;
  if (!eventConfig) return;

  const currentAdapter = context.adapter;
  const getters = adapters[currentAdapter as AdapterKey] ?? legacyGetters // fallback for legacy;

  const entries = await Promise.all(
    eventConfig.requiredParams.map(async (param) => {
      const getter = getters[param as keyof typeof getters] as GetterFn;

      if (typeof getter !== 'function') {
        console.error(`[DT] Missing getter "${param}" for adapter "${currentAdapter}"`);
        return [param, null] as const;
      }

      return [param, await getter(context, config)] as const;
    })
  );

  const parameters = Object.fromEntries(entries);

  if (eventName === 'AUTH_ACTION') {
    parameters.type = await getAuthActionType(context, parameters.type);
  }

  if (Array.isArray(parameters.items) && parameters.items.length) {
    parameters.items = itemsWithPromotion(parameters.items, eventName);
  }

  return parameters;
}